




















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {Profile} from '@/model/network/profile/Profile';
import {IpMode} from '@/model/network/IpMode';
import {ConnectionTypeMetadata} from '@/model/network/connection/ConnectionType';

import NetworkIpSettingsEditor from '@/components/Networking/Profile/NetworkIpSettingsEditor.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkIpSettingsEditor},
})
export default class NetworkConnectRetryEditor extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  private value!: number;

  private retryRules = [
    (value: any) => !!value || value === 0 || 'Required',
    (value: number) => (!isNaN(value) && value >= -1) || 'Enter a positive number or select in the list',
  ];

  private ConnectionRetryValues = [
    -1,
    0,
    1,
    2,
    3,
    5,
    10,
  ];

  private ConnectionRetryLabel(value: number) {

    if (isNaN(value) || value < -1) {
      return value;
    }

    switch (value) {
      case 0:
        return 'Forever';

      case 1:
        return 'Disabled';

      case -1:
        return 'Default (4 retries)';

      default:
        return `${value} retries`;
    }
  }

  private onValueChanged(value: string) {
    this.$emit('input', +value);
  }
}
